/*
 * Copyright (c) 2021-2022. Revo Digital
 * ---
 * Author: gabrielecavallo
 * File: MleCustomSelect.tsx
 * Project: mle-client-n
 * Committed last: 2022/6/10 @ 1518
 * ---
 * Description:
 */

import {ItemRenderer, Select} from '@blueprintjs/select';
import React, {useCallback, useState} from 'react';
import {Button, MenuItem} from '@blueprintjs/core';
import {HasName, MleSelectProps} from '../../../../common/utils';

/**
 * Selettore generale
 * @param props
 * @constructor
 */
export const MleCustomSelect = <T extends HasName>(props: MleSelectProps<T>) => {
  const [selectedValue, setSelectedValue] = useState<T | undefined>(props.initalValue);

  const CustomSelect = Select.ofType<T>();

  const itemRenderer: ItemRenderer<T> = (item, {
    handleClick,
    modifiers,
  }) => {
    if (!modifiers.matchesPredicate)
      return null;
    return <MenuItem
        key={ props.renderText(item) }
        active={ modifiers.active }
        disabled={ modifiers.disabled }
        label={ props.renderLabel(item) }
        text={ props.renderText(item) }
        onClick={ handleClick }
    />;
  };

  const handleItemSelect = useCallback((item: T) => {
    setSelectedValue(item);
    props.onSelect(item);
  }, [props, setSelectedValue]);

  return (
      <CustomSelect
          { ...props }
          filterable={ false }
          itemRenderer={ itemRenderer }
          items={ props.items }
          onItemSelect={ handleItemSelect }
      >
        <Button
            intent={props.intent}
            icon={props.icon}
            rightIcon="caret-down"
            text={selectedValue ? `${selectedValue.name || selectedValue}` : '(nessuna selezione)'}
        />
      </CustomSelect>
  );
};

